/**
 * AI Wingman Logo Component
 * Minimalist wing-inspired logo with gradient
 */
import { Box, SxProps, Theme } from "@mui/material";

interface LogoProps {
  size?: number;
  showText?: boolean;
  sx?: SxProps<Theme>;
}

export default function Logo({ size = 40, showText = false, sx }: LogoProps) {
  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, ...sx }}>
      <img
        src="/logo.png"
        alt="AI Wingman Logo"
        width={size}
        height={size}
        style={{ display: "block" }}
      />

      {showText && (
        <Box
          component="span"
          sx={{
            fontWeight: 600,
            fontSize: size * 0.45,
            color: "text.primary",
            letterSpacing: "-0.02em",
          }}
        >
          AI Wingman
        </Box>
      )}
    </Box>
  );
}

/**
 * Simplified icon-only version for favicons and small displays
 */
export function LogoIcon({ size = 32 }: { size?: number }) {
  return (
    <img
      src="/logo.png"
      alt="AI Wingman"
      width={size}
      height={size}
      style={{ display: "block" }}
    />
  );
}

/**
 * Alternative wing design - more abstract/modern
 */
export function LogoWing({ size = 40 }: { size?: number }) {
  return (
    <img
      src="/logo.png"
      alt="AI Wingman"
      width={size}
      height={size}
      style={{ display: "block" }}
    />
  );
}
